module.exports = __webpack_public_path__ + "static/media/nimes_tempel.8e9f2afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_tempel.png
// module id = 737
// module chunks = 0